import { AppBar, Tab, Tabs, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, Outlet, useLocation, useOutletContext } from 'react-router-dom';
import PersonIcon from "@mui/icons-material/Person";
import PeopleIcon from '@mui/icons-material/People';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { useDispatch, useSelector } from 'react-redux';
import { selectHasMarketplace, setHasMarketplace, setPermissions } from 'store/slices/appSlice/AppSlice';
import { useGetPermissionsQuery } from 'store/apis/AccountApi';
import { EditSkeleton } from 'components/admin/admin.overlays';

function getTabValueFromPath(pathname) {
  if (pathname.includes('/marketplace/residents')) return 0;
  if (pathname.includes('marketplace/guest')) return 1;
  if (pathname.includes('marketplace/submitted')) return 2;
  return 0;
}

export default function Marketplace() {
  const currentLocation = useLocation();  
  const dispatch = useDispatch();
  const currentUserData = useOutletContext();
  const hasMarketplace = useSelector(selectHasMarketplace);

  const [tabValue, setTabValue] = useState(() => getTabValueFromPath(currentLocation.pathname));

  const { data: permissions, isFetching: permissionsLoading } = useGetPermissionsQuery();
  
  useEffect(() => {
    if (permissions?.length) {
      dispatch(setPermissions(permissions));
      dispatch(setHasMarketplace(permissions.includes("Marketplace")));
    }
  }, [permissions]);

  useEffect(() => {
    setTabValue(getTabValueFromPath(currentLocation.pathname));
  }, [currentLocation]);
  
  if (!hasMarketplace && !permissionsLoading) {
    return (
      <Typography variant="h6" sx={{ textAlign: "center", marginTop: "2rem", color: "gray" }}>
        Marketplace is not enabled for this community.
      </Typography>
    );
  }

  return (
    <>
      {permissionsLoading ? (
        <EditSkeleton />
      ) : (
        <>
          <AppBar
            position="static"
            sx={{
              borderRadius: "0 !important",
              borderTop: "1px solid lightgray",
              boxShadow: "4px 4px .5rem rgba(0, 0, 0, .35) !important"
            }}
          >
            <Tabs
              variant="fullWidth"
              value={tabValue}
              TabIndicatorProps={{
                sx: {
                  backgroundColor: "#ff3f28 !important"
                }
              }}
            >
              <Tab component={Link} to={"/marketplace/residents"} className="order-tab" label="Resident" icon={<PersonIcon />} iconPosition="top"/>
              <Tab component={Link} to={"/marketplace/guest"} className="order-tab" label="Guest / Employee" icon={<PeopleIcon />} iconPosition="top"/>
              <Tab component={Link} to={"/marketplace/submitted"}className="order-tab" label="Submitted" icon={<AssignmentTurnedInIcon />} iconPosition="top"/>
            </Tabs>
          </AppBar>
          <Outlet context={currentUserData} />
        </>
      )}
    </>
  );
}